import { render, staticRenderFns } from "./DeactivateWallet.vue?vue&type=template&id=08431c39&scoped=true"
import script from "./DeactivateWallet.vue?vue&type=script&lang=js"
export * from "./DeactivateWallet.vue?vue&type=script&lang=js"
import style0 from "./DeactivateWallet.vue?vue&type=style&index=0&id=08431c39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08431c39",
  null
  
)

export default component.exports